/* unplugin-vue-components disabled */import { render } from "./cart-alert-box.vue?vue&type=template&id=57df9e6d"
import script from "./cart-alert-box.vue?vue&type=script&lang=js"
export * from "./cart-alert-box.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__